import { ArrowUpRight } from "lucide-react";

const PRODUCTS = ["SmartContainer™", "CommodityBid™", "RFQ™", "Estimated CIF™", "FreightIQ™", "Inspection™", "Live Shipment Tracking™"];
const COMPANY = ["About", "Customers", "Security", "Pricing", "Contact"];
const RESOURCES = ["Documentation", "Changelog", "Status", "API", "Brand"];

export const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-slate-900 text-white font-display font-bold tracking-tighter">
                DM
              </span>
              <span className="font-display text-lg font-medium tracking-tight text-slate-900">DeMaxtore</span>
              <span className="text-[10px] tracking-[0.22em] uppercase font-semibold text-slate-400">Workspace</span>
            </div>
            <p className="mt-5 text-[14px] text-slate-500 max-w-md leading-relaxed">
              The procurement intelligence Workspace for import-driven businesses. From RFQ to delivered cargo — one place, one source of truth.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 text-[11px] tracking-widest uppercase font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-3 py-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 pulse-dot" />
              All systems operational
            </div>
          </div>

          <FooterCol title="Workspace" items={PRODUCTS} />
          <FooterCol title="Company" items={COMPANY} />
          <FooterCol title="Resources" items={RESOURCES} />
        </div>

        <div className="mt-14 pt-8 border-t border-slate-100 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-[12px] text-slate-400">
            © {new Date().getFullYear()} DeMaxtore. All trademarks are property of their respective owners.
          </p>
          <div className="flex items-center gap-5 text-[12px] text-slate-500">
            <a className="hover:text-slate-900" href="#privacy">Privacy</a>
            <a className="hover:text-slate-900" href="#terms">Terms</a>
            <a className="hover:text-slate-900" href="#dpa">DPA</a>
            <a className="hover:text-slate-900 inline-flex items-center" href="#status">
              status.demaxtore.app <ArrowUpRight className="ml-0.5 h-3 w-3" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, items }) => (
  <div className="md:col-span-2">
    <div className="text-[10px] tracking-[0.22em] uppercase font-bold text-slate-400">{title}</div>
    <ul className="mt-5 space-y-2.5">
      {items.map((i) => (
        <li key={i}>
          <a className="text-[13px] text-slate-700 hover:text-slate-900" href="#">
            {i}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
